function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { Arrowchevron2LeftIcon, Arrowchevron2RightIcon, ArrowchevronLeftIcon, ArrowchevronRightIcon, EmptyIcon } from '@bfe/moly-icons';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import DatePicker from 'rc-picker/lib/locale/en_US';
import { useMemo } from 'react';
import Date from "../asset/date";
import Time from "../asset/time";
import { jsx as _jsx } from "react/jsx-runtime";
export var locale = {
  locale: 'en_US',
  DatePicker: DatePicker,
  Modal: {
    confirmText: 'Confirm',
    cancelText: 'Cancel'
  },
  Popconfirm: {
    confirmText: 'Confirm',
    cancelText: 'Cancel'
  },
  Select: {
    noDataText: 'No data'
  }
};
function simpleHash(str) {
  var hash = 5381;
  for (var i = 0; i < str.length; i++) {
    hash = hash * 33 ^ str.charCodeAt(i);
  }
  return hash >>> 0;
}
var getCircularReplacer = function getCircularReplacer() {
  var seen = new WeakSet();
  return function (key, value) {
    if (_typeof(value) === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};
export var generateUniqueId = function generateUniqueId(params) {
  var string = JSON.stringify(params, getCircularReplacer());
  return simpleHash(string);
};
export var allFalse = function allFalse(obj, keys) {
  if (!obj) return true;
  return keys.every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === false;
  });
};
var useSharedProps = function useSharedProps(props, type) {
  var _props$locale;
  var prevIcon = useMemo(function () {
    return /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {
      style: {
        color: '#81858C'
      }
    });
  }, []);
  var nextIcon = useMemo(function () {
    return /*#__PURE__*/_jsx(ArrowchevronRightIcon, {
      style: {
        color: '#81858C'
      }
    });
  }, []);
  var superPrevIcon = useMemo(function () {
    return /*#__PURE__*/_jsx(Arrowchevron2LeftIcon, {
      style: {
        color: '#81858C'
      }
    });
  }, []);
  var superNextIcon = useMemo(function () {
    return /*#__PURE__*/_jsx(Arrowchevron2RightIcon, {
      style: {
        color: '#81858C'
      }
    });
  }, []);
  var clearIcon = useMemo(function () {
    return /*#__PURE__*/_jsx(EmptyIcon, {
      color: "var(--bds-gray-t2, #81858C)",
      width: 18
    });
  }, []);
  var suffixIcon = useMemo(function () {
    return props.picker === 'time' ? /*#__PURE__*/_jsx(Time, {}) : /*#__PURE__*/_jsx(Date, {});
  }, [props.picker]);
  // props不一致则生成不同id，同样的props同id无问题
  var paramsID = generateUniqueId(props);
  var defaultPlaceholder = function defaultPlaceholder(picker, type) {
    if (picker === 'time') {
      return 'Input Time';
    }
    if (type === 'range') {
      return ['Start Date', 'End Date'];
    }
    return 'input Date';
  };
  var rangeInH5 = function rangeInH5(isMobile, type, originShowTime) {
    if (type === 'range') {
      if (isMobile) {
        var showTime = _objectSpread({
          showHour: false,
          showMinute: false,
          showSecond: false
        }, originShowTime);
        return showTime;
      }
      return originShowTime;
    }
    return originShowTime;
  };
  return _objectSpread({
    prevIcon: prevIcon,
    nextIcon: nextIcon,
    superPrevIcon: superPrevIcon,
    superNextIcon: superNextIcon,
    clearIcon: clearIcon,
    suffixIcon: suffixIcon,
    generateConfig: dayjsGenerateConfig,
    locale: (_props$locale = props.locale) !== null && _props$locale !== void 0 ? _props$locale : locale.DatePicker,
    allowClear: true,
    // 默认开启
    placeholder: defaultPlaceholder(props.picker, type),
    // date | time |  startdate, enddate
    inputReadOnly: false,
    prefixCls: "moly-datepicker",
    paramsID: paramsID,
    showTime: rangeInH5(props.isMobile, type, props.showTime)
  }, props);
};
export default useSharedProps;